import type { DynamicFormRef } from '@myosh/odin-components';
import { useCallback } from 'react';
import useActiveRecordRef from './use-active-record-ref';

const useDynamicFormNotifier = (dynamicFormId: string) => {
  const { activeRecordReference } = useActiveRecordRef();

  const notifyDirty = useCallback((dynamicFormReference: DynamicFormRef | null, forceDirty = false) => {
    const isDirty = Boolean(dynamicFormReference?.formIsDirty()) || forceDirty;
    if (isDirty) {
      activeRecordReference.current?.setItemDirty(dynamicFormId);
    } else {
      activeRecordReference.current?.clearItemDirty(dynamicFormId);
    }
  }, []);

  const notifySaveFailed = useCallback((id: string) => {
    activeRecordReference.current?.setItemSaveFailed(id);
  }, []);

  const notifySaveSucceeded = useCallback((id: string) => {
    activeRecordReference.current?.clearItemDirty(id);
  }, []);

  return {
    notifyDirty,
    notifySaveFailed,
    notifySaveSucceeded,
  };
};

export default useDynamicFormNotifier;
